import { HomeBody } from "@/components/home-body";
import { NEXT_COHORT, NEXT_COHORT_TITLE } from "@/lib/cohorts";
import { courseWithNextCohort } from "@/lib/seo-schemas";
import { useSEO } from "@/lib/use-seo";

export const Home = () => {
  useSEO({
    title: "AI for HR Mastermind | Build AI Skills for HR in 5 Weeks",
    description: "The only AI program where HR leaders build, not just learn. Work with an AI engineer and I/O Psychologist to create a working prototype in 5 weeks. 200+ graduates from Netflix, Duracell, T-Mobile.",
    path: "/",
    jsonLd: courseWithNextCohort({
      name: NEXT_COHORT_TITLE,
      startDate: NEXT_COHORT.startDateIso,
    }),
  });
  return <HomeBody />;
};

export default Home;
